import {
  createErrorHandlerWrapper,
  createRequestInterceptorWrapper,
} from '@mathflat/domain/@entities/Auth/axiosJwtSetup'
import { jwtTokenService } from '@mathflat/domain/@entities/Auth/jwtTokenService'
import { ReissueSingleFlightScheduler } from '@mathflat/domain/@entities/Auth/ReissueSingleFlightScheduler'

import { localStorageService } from '@/service/storage.service'

import { datadogClient } from '../modules/datadog/datadogClient'

/**
 * JWT 토큰 재발급 스케줄러
 *
 * Teacher 앱 전체에서 공유하는 단일 인스턴스입니다.
 * 여러 axios 요청이 동시에 토큰 재발급을 시도해도 한 번만 실행되도록 보장합니다.
 */
export const reissueSingleFlightScheduler = new ReissueSingleFlightScheduler()

/**
 * JWT Request Interceptor Wrapper
 *
 * tokenService와 scheduler를 미리 바인딩한 wrapper입니다.
 * 모든 axios 인스턴스에서 재사용할 수 있습니다.
 *
 * @example
 * maxios.interceptors.request.use(
 *   wrapRequestInterceptorWithJwt((config) => {
 *     // 앱별 로직
 *     return config
 *   })
 * )
 */
export const wrapRequestInterceptorWithJwt = createRequestInterceptorWrapper(
  jwtTokenService,
  reissueSingleFlightScheduler,
)

/**
 * JWT Error Handler Wrapper
 *
 * 401 에러 발생 시 자동으로 토큰을 재발급하고 요청을 재시도합니다.
 *
 * @example
 * maxios.interceptors.response.use(
 *   (response) => response,
 *   wrapErrorHandlerWithJwt(
 *     async (error) => { ... },
 *     async (originalRequest, newAccessToken) => {
 *       originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
 *       return maxios(originalRequest)
 *     }
 *   )
 * )
 */
export const wrapErrorHandlerWithJwt = createErrorHandlerWrapper(
  jwtTokenService,
  reissueSingleFlightScheduler,
  () => {
    const loginPath = localStorageService.getItem('LOGIN_PATH') || '/login'
    sessionStorage.clear()
    localStorage.clear()
    window.location.href = loginPath

    return Promise.resolve()
  },
)
